import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full text-gray-darker py-2 content-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "flex items-center gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideHeaderText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Notes haven't been added yet, would you like to add new ones?"))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn, {
      variant: "flat",
      disabled: _ctx.adding,
      class: "mb-4",
      color: "grey-lighten-1",
      onClick: _ctx.newNoteFocus
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode(" Add Note + ", -1)
      ]))]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    (_ctx.adding)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`flex items-center ${_ctx.addTreatment ? 'justify-between' : 'justify-end'}`)
        }, [
          (_ctx.adding && _ctx.addTreatment)
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 0,
                style: {"width":"40%","max-width":"40%"},
                label: "Select treatment",
                variant: "outlined",
                modelValue: _ctx.selectedTreatment,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTreatment) = $event)),
                items: _ctx.treatments,
                "item-value": "uuid",
                "item-title": "name"
              }, null, 8, ["modelValue", "items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_switch, {
            label: "Attach treatment",
            modelValue: _ctx.addTreatment,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addTreatment) = $event))
          }, null, 8, ["modelValue"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.adding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_text_field, {
            ref: "new-note",
            "append-inner-icon": "mdi-checkbox-marked-circle-outline",
            key: "note-treatmentDialogAdd",
            "clear-icon": "mdi-close-circle",
            clearable: "",
            color: _ctx.error ? 'red' : 'primary',
            hint: _ctx.hint,
            label: "Add a note",
            modelValue: _ctx.newNote,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newNote) = $event)),
            variant: "outlined",
            "persistent-hint": _ctx.error,
            "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (_ctx.createNote($event))),
            "onClick:clear": _ctx.clearNote,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleFocusedInput(`note-treatmentDialogAdd`, _ctx.newNote))),
            onBlur: _ctx.checkIsSavedNewNote,
            class: "flex-grow"
          }, null, 8, ["color", "hint", "modelValue", "persistent-hint", "onClick:clear", "onBlur"]),
          _createVNode(_component_v_btn, {
            icon: "mdi-delete",
            variant: "text",
            color: "grey",
            onClick: _ctx.toggleOffAddingNote
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}